const TIKTOK_VIDEO_PATH = /tiktok\.com\/@([^/?#]+)\/video\/(\d+)/i;
const TIKTOK_EMBED_WIDTH = 325;
const TIKTOK_EMBED_HEIGHT = 578;

interface Props {
  anchorId?: string;
  videoId?: string;
  citeUrl?: string;
  authorId?: string;
  title?: string;
}

const parseTikTokVideoUrl = (value?: string) => {
  if (!value) return {};

  const match = value.match(TIKTOK_VIDEO_PATH);
  if (!match) return {};

  return { authorId: match[1], videoId: match[2] };
};

const TikTok = ({ anchorId, videoId, citeUrl, authorId, title }: Props) => {
  const parsed = parseTikTokVideoUrl(citeUrl);
  const resolvedVideoId = videoId || parsed.videoId;
  const resolvedAuthorId = authorId || parsed.authorId;
  const playerUrl = resolvedVideoId
    ? `https://www.tiktok.com/player/v1/${resolvedVideoId}?embed_from=oembed&music_info=1&description=1`
    : undefined;

  return (
    <div
      id={anchorId}
      style={{
        padding: '0.25rem',
        margin: '0 auto',
        width: TIKTOK_EMBED_WIDTH,
        minWidth: TIKTOK_EMBED_WIDTH,
        flexShrink: 0,
      }}
    >
      {playerUrl ? (
        <iframe
          src={playerUrl}
          width={TIKTOK_EMBED_WIDTH}
          height={TIKTOK_EMBED_HEIGHT}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          title={resolvedAuthorId ? `TikTok video by @${resolvedAuthorId}` : 'TikTok video'}
          style={{
            display: 'block',
            width: TIKTOK_EMBED_WIDTH,
            height: TIKTOK_EMBED_HEIGHT,
            border: 0,
            borderRadius: '0.5rem',
          }}
        />
      ) : (
        <blockquote
          className="tiktok-embed rounded-sm"
          cite={citeUrl}
          data-video-id={resolvedVideoId}
          data-from-oembed
          style={{ minWidth: TIKTOK_EMBED_WIDTH, maxWidth: TIKTOK_EMBED_WIDTH }}
        >
          <section>
            <a
              target="_blank"
              title={resolvedAuthorId ? `@${resolvedAuthorId}` : undefined}
              href={resolvedAuthorId ? `https://www.tiktok.com/@${resolvedAuthorId}` : citeUrl}
              rel="noreferrer"
            >
              {resolvedAuthorId ? `@${resolvedAuthorId}` : citeUrl}
            </a>
            {title ? <p>{title}</p> : null}
          </section>
        </blockquote>
      )}
    </div>
  );
};

export { TikTok };
